import React, { useEffect, useState, useContext } from "react";
import Lang from '../lang/translations';
import Context from '../context/context';

const config = require("../_helpers/configServizi");


export default function Recensioni(props) { 

    const  context = useContext(Context)
    const domain = window.location.hostname;
    const [recensioni, setRecensioni] = useState([]);

    const Star = () => (
        <svg height="16px" width="16px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 53.867 53.867" xmlSpace="preserve">
            <polygon style={{ fill: '#EFCE4A' }} points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "/>
        </svg>
    );
    
    const WhiteStar = () => (
        <svg height="16px" width="16px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 53.867 53.867" xmlSpace="preserve">
            <polygon style={{ fill: '#fff' ,stroke: '#EFCE4A', strokeWidth:'4px'}} points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "/>
        </svg>
    );

    useEffect(() => {
		window.scrollTo({top: 0, behavior: 'smooth'});

	});


    useEffect(() => {  
        setRecensioni(Lang({recensioni:true, quante: 3, age_range: config.servizi[domain].age_range_recensioni, placeholders:{servizio:config.servizi[domain].title}}))
      
   },[]);


   function CreaStelline(quante){
   
    const stars = []
    for(let i=0;i<quante;i++){
        stars.push(<Star key={i} />);
    }
    if(quante<5){
        const mancanti = 5 - quante
        for(let i=0;i<mancanti;i++){
               stars.push(<WhiteStar key={i+10} />);
        }
    }
    return <div style={{ display: 'flex' }}>{stars}</div>;
   
   }
   
  

    return (<div className="puchasePage">
         
        <div className="filters-no-padding" role="main">
           
            <div class="review-title">
                <h3><Lang w={"cosa_dicono"} page={"recensioni"}/></h3>
            </div>
            <div class="contenitore_review row">
                {recensioni && (
                     recensioni.map(el => (
               
                        <div class="review-container col-md-4">
                            <div class="review-top">
                               
                               
                                    <div class="review-item">
                                        <img class="review-img" src={config.servizi[domain].url_foto_utente+"/foto_recensioni/"+el.nome_immagine} alt={el.Utente}/>
                                        <div class="review-body">
                                            <strong>{el.Utente}</strong>, {el.Età} <Lang w={"anni"} page={"match"}/><br/>
                                            <div class="review-body-p">
                                                {el.Recensione}
                                            </div>
                                        </div>
                                    <div class="review-stars">
                                        {CreaStelline(el.Stelle)}
                                    </div>
                                </div>
                        </div>
                        </div>
                    )
                )  
                    

                    )}
                   
                </div>
            </div>
    
       </div>
            )

}